import { Component, OnDestroy } from '@angular/core';
import { CommonForm, CommonFormComponent } from '../common-form/common-form.component';
import { CommonModule } from '@angular/common';
import { WorkspaceService } from '@workspaces/services/workspace.service';
import { catchError, EMPTY, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CreateWorkspaceRequest } from '@workspaces/models/workspaces';
import { Store } from '@ngrx/store';
import { WorkspaceFetch, WorkspaceFetched } from '@workspaces/store/workspace-list.feature';
import { AppState } from 'src/app/state/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-common-form',
  templateUrl: './create-common-form.component.html',
  standalone: true,
  imports: [CommonFormComponent, CommonModule]
})
export class CreateCommonFormComponent implements OnDestroy {
  public isSubmitting = false;
  private readonly sub = new Subscription();
  constructor(
    private readonly workspaceService: WorkspaceService,
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly actions$: Actions,
    private readonly snackbar: MatSnackBar
  ) {}
  public onSubmit(commonFormValues: CommonForm) {
    this.isSubmitting = true;
    const mappedCommonForm: CreateWorkspaceRequest = {
      description: commonFormValues.description,
      name: commonFormValues.name,
      template_id: commonFormValues.templateId,
      template_version: commonFormValues.templateVersion,
      ai_doc_info: commonFormValues.docAiInfo
    };
    this.sub.add(
      this.workspaceService
        .createWorkspace(mappedCommonForm)
        .pipe(catchError(() => this.handleError()))
        .subscribe(async response => {
          this.isSubmitting = false;
          if (response) {
            const workspaceId = response.id;
            //Fetch before navigate to update cache -> Otherwise it will check against current cache which doesn't contain this new
            this.subForWorkspaceFetchFinish(workspaceId);
            this.store.dispatch(WorkspaceFetch({ workspaceId: workspaceId }));
          }
        })
    );
  }

  subForWorkspaceFetchFinish(workspaceId: string) {
    this.sub.add(
      this.actions$.pipe(ofType(WorkspaceFetched)).subscribe(async () => {
        await this.router.navigate(['/workspaces', workspaceId]);
      })
    );
  }

  private handleError(): Observable<never> {
    this.isSubmitting = false;
    this.snackbar.open('Error during worksapce creation', 'Close', { duration: 5000, panelClass: ['error-snackbar'] });
    return EMPTY;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
